import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/homepage';

export default function FeaturedSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        {/* Section header */}
        <div className="mb-12 md:mb-16">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black text-foreground-900 font-heading leading-tight">
            热点爆料<span className="text-primary-500">.</span>
          </h2>
          <p className="text-foreground-500 text-base md:text-lg mt-3 max-w-xl leading-relaxed">
            网红塌房现场一手爆料，黑料每日更新，吃瓜爆料不停歇
          </p>
        </div>

        {/* Cards grid - variable width on hover */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article, idx) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className={`group relative rounded-2xl overflow-hidden aspect-[3/4] cursor-pointer transition-all duration-500 ${
                idx === 0
                  ? 'md:col-span-1 hover:md:col-span-2'
                  : ''
              }`}
            >
              <img
                src={article.imageUrl}
                alt={article.title}
                title={article.title}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent"></div>

              {/* Tag */}
              <div className="absolute top-4 left-4">
                <span className={`px-2.5 py-1 rounded-md text-background-50 text-xs font-bold ${article.tagColor}`}>
                  {article.tag}
                </span>
              </div>

              {/* Description on hover */}
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="text-background-50/70 text-xs font-medium mb-1.5 block">
                  {article.category}
                </span>
                <h3 className="text-background-50 font-bold text-lg md:text-xl leading-snug">
                  {article.title}
                </h3>
                <p className="text-background-50/60 text-sm mt-2 leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-500 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 mt-3 text-background-50/50 text-xs">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}